<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <jm-crumbs :append="[this.editData.username]" />
          <info-menu :is-new="isNew" />
          <div class="basic-information">
            <el-form
              :model="editData"
              class="error-form basic-table basic-table-div"
            >
              <el-collapse v-model="activeNames">
                <el-collapse-item title="详细信息" name="1">
                  <el-row>
                    <el-col :span="2">姓名</el-col>
                    <el-col :span="4">
                      <el-input v-model.trim="editData['username']" :class="['jm-input220',]" :disabled="infoReadOnly() && !canEditByCreator()" />
                    </el-col>
                    <el-col :span="2">昵称</el-col>
                    <el-col :span="4">
                      <el-input v-model.trim="editData['nickname']" :class="['jm-input220',]" :disabled="infoReadOnly() && !canEditByCreator()" />
                    </el-col>
                    <el-col :span="2">采集功能</el-col>
                    <el-col :span="4">
                      <el-select
                        v-if="isNew"
                        class="jm-input150"
                        v-model="editData['create_point']"
                        clearable
                      >
                        <template v-for="(item, key) in creator_list">
                          <el-option

                            v-if="item.userid < 0 && (item.adminView === 1 || $hasPermission([52]))"
                            :key="key"
                            :label="item.username"
                            :value="item.userid"
                          />
                        </template>
                      </el-select>
                      <span v-else>{{ editData.create_point_value }}</span>
                      <span v-if="!isNew">({{ editData.create_time }})</span>
                    </el-col>
                    <el-col :span="2">推广人</el-col>
                    <el-col :span="4">
                      <el-select
                        v-if="isNew"
                        class="jm-input150"
                        v-model="editData['custom_promoter']"
                        clearable
                      >
                        <template v-for="(item, key) in creator_list">
                          <el-option
                            v-if="item.userid > 0"
                            :key="key"
                            :label="item.username"
                            :value="item.userid"
                          />
                        </template>
                      </el-select>
                      <span v-else>{{ editData.custom_promoter_value }}</span>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">性别</el-col>
                    <el-col :span="8">
                      <jm-dict-select
                        :disabled="infoReadOnly() && !canEditByCreator()"
                        class="jm-input135"
                        type="job"
                        v-model="editData.sex"
                        dict-type="sex"
                        name="sex" />
                    </el-col>
                    <el-col :span="2">生日</el-col>
                    <el-col :span="5">
                      <el-date-picker
                        :disabled="infoReadOnly() && !canEditByCreator()"
                        :editable="false"
                        v-model="editData['birthday']"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        clearable
                        placeholder="请选择"
                      />
                    </el-col>
                    <el-col :span="2">邮箱</el-col>
                    <el-col :span="5">
                      <el-input v-model.trim="editData['email']" :class="['jm-input220',]" :disabled="infoReadOnly() && !canEditByCreator()" />
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">电话</el-col>
                    <el-col :span="8">
                      <el-input v-model.trim="editData['tel']" :class="['jm-input220',]" :disabled="infoReadOnly() && !canEditByCreator()" />
                      <em v-if="!isNew && editData.tel_location">归属地区：{{ editData.tel_location }}</em>
                    </el-col>
                    <el-col :span="2">QQ</el-col>
                    <el-col :span="5">
                      <el-input v-model.trim="editData['qq']" :class="['jm-input220',]" :disabled="infoReadOnly() && !canEditByCreator()" />
                    </el-col>
                    <el-col :span="2">微信</el-col>
                    <el-col :span="5">
                      <el-input v-model.trim="editData['wechat']" :class="['jm-input220',]" :disabled="infoReadOnly() && !canEditByCreator()" />
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">学历</el-col>
                    <el-col :span="15">
                      <jm-dict-select
                        :disabled="infoReadOnly()"
                        class="jm-input135"
                        type="job"
                        v-model="editData.education"
                        dict-type="education"
                        name="education"/>
                    </el-col>
                    <el-col :span="2">日语等级</el-col>
                    <el-col :span="5">
                      <jm-dict-select
                        :disabled="infoReadOnly()"
                        class="jm-input135"
                        type="job"
                        v-model="editData.jap_level"
                        dict-type="jp_level"
                        name="jp_level"/>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">学位证</el-col>
                    <el-col :span="8">
                      <jm-dict-select
                        :disabled="infoReadOnly()"
                        class="jm-input135"
                        type="job"
                        v-model="editData.education_card"
                        dict-type="education_card"
                        name="education_card"/>
                    </el-col>
                    <el-col :span="2">专业</el-col>
                    <el-col :span="5">
                      <el-input :disabled="infoReadOnly()" v-model.trim="editData['major']" :class="['jm-input220',]" />
                    </el-col>
                    <el-col :span="2">日语证书</el-col>
                    <el-col :span="5">
                      <jm-dict-select
                        :disabled="infoReadOnly()"
                        class="jm-input135"
                        type="job"
                        v-model="editData.jap_card"
                        dict-type="jap_card"
                        name="jap_card"/>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">简历来源渠道</el-col>
                    <el-col :span="22">
                      <jm-channel
                        ref="channelRef"
                        :disabled="!$hasPermission(1) && !isNew"
                        :exclude-disable="!$hasPermission(1) && !isNew"
                        :is-all="false"
                        v-model="editData['channel']"
                        clearable
                        filterable
                      />
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">学员进度</el-col>
                    <el-col :span="8">
                      <jm-dict-select
                        :disabled="infoReadOnly()"
                        class="jm-input135"
                        type="job"
                        v-model="editData.member_level"
                        dict-type="member_level"
                        name="member_level"/>
                    </el-col>
                    <el-col :span="2">项目类型</el-col>
                    <el-col :span="5">
                      <jm-dict-select
                        :disabled="infoReadOnly()"
                        class="jm-input135"
                        type="job"
                        v-model="editData.project_type"
                        dict-type="recruit_type"
                        name="recruit_type"/>
                    </el-col>
                    <el-col :span="2">技术类别</el-col>
                    <el-col :span="5">
                      <el-input :disabled="infoReadOnly()" v-model.trim="editData['skill_type']" :class="['jm-input220',]" />
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">简历上传</el-col>
                    <el-col :span="8">
                      <jm-upload
                        :disabled="infoReadOnly()"
                        :on-success="uploadBack"
                        :on-progress="loading"
                        class="upload-demo"
                        v-loading="exporting"
                        :show-file-list="false"
                        action="/newfib.php/job/Attach/uploadFile"
                      >
                        <el-button size="small" type="primary">点击上传</el-button>
                      </jm-upload>
                      <a
                        class="edit-file-download"
                        title="下载"
                        v-if="editData['file_name']"
                        :download="editData['file_name']"
                        :href="'/'+editData['upload_file']"
                      >{{ editData['file_name'] }}</a>
                    </el-col>
                    <el-col :span="2">学员是否有效</el-col>
                    <el-col :span="5">
                      <jm-dict-select
                        :disabled="infoReadOnly()"
                        class="jm-input135"
                        type="job"
                        v-model="editData.is_effective"
                        dict-type="is_effective"
                        name="is_effective"/>
                    </el-col>
                    <el-col :span="2">活动编码</el-col>
                    <el-col :span="5">
                      <el-input
                        v-model.trim="editData['activity_code']"
                        :class="['jm-input220',]" :disabled="!canEditByCreator()"/>
                    </el-col>
                  </el-row>
                </el-collapse-item>
                <el-collapse-item title="签约信息" name="2">
                  <el-row>
                    <el-col :span="2">签约状态</el-col>
                    <el-col :span="8">
                      <el-select :disabled="infoReadOnly()" class="jm-input135" v-model="editData['sign_status']" clearable>
                        <el-option
                          v-for="(item, key) in sign_status"
                          :key="key"
                          :label="item"
                          :value="key"
                        />
                      </el-select>
                    </el-col>
                    <el-col :span="2">签约日期</el-col>
                    <el-col :span="12">
                      <el-date-picker
                        :disabled="infoReadOnly()"
                        :editable="false"
                        v-model="editData['sign_date']"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        clearable
                        placeholder="请选择"
                      />
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">咨询老师</el-col>
                    <el-col :span="8">
                      <el-select :disabled="infoReadOnly()" v-if="isNew" class="jm-input150" v-model="editData['consult_teacher']">
                        <el-option
                          v-for="(item, key) in consult_teacher_add"
                          :key="key"
                          :label="item"
                          :value="key"
                        />
                      </el-select>
                      <el-select :disabled="infoReadOnly()" class="jm-input150" v-model="editData['consult_teacher']" v-else>
                        <el-option
                          v-for="(item, key) in consult_teacher_edit"
                          :key="key"
                          :label="item"
                          :value="key"
                        />
                      </el-select>
                    </el-col>
                    <el-col :span="2">材料老师</el-col>
                    <el-col :span="12">
                      <el-select
                        :disabled="infoReadOnly() || isNew"
                        class="jm-input150"
                        v-model="editData['clerk_teacher']"
                        clearable
                      >
                        <el-option
                          v-for="(item, key) in clerk_teacher"
                          :key="key"
                          :label="item"
                          :value="key"
                        />
                      </el-select>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">备注</el-col>
                    <el-col :span="22">
                      <el-input
                        :disabled="infoReadOnly()"
                        type="textarea"
                        :rows="2"
                        placeholder="请输入备注"
                        v-model="editData['remark']"
                      />
                    </el-col>
                  </el-row>
                </el-collapse-item>
              </el-collapse>
            </el-form>
          </div>
          <div class="jm-primary">
            <template v-if="isJobSite">
              <el-button
                v-if="!infoReadOnly() || canEditByCreator()"
                type="primary"
                :loading="saving"
                @click="save()"
              >保存</el-button>
              <template v-if="!isNew && isJobSite && $hasPermission([90, 98, 109, 114, 116])">
                <el-button type="danger" v-if="!syncDialog.finished" @click="showSyncDialog">同步到其他系统</el-button>
                <el-button
                  v-if="syncDialog.linked"
                  type="success"
                  @click="showSyncMsgDialog"
                >资源动态提醒</el-button>
              </template>
            </template>
          </div>
          <div v-if="isJobSite">
            <div class="bind">
              活动记录
            </div>
            <jm-tableList
              url="/job/member/showActivityLog"
              :search-data="{userid: $route.params.id}"
              row-key="id"
            >
            </jm-tableList>
          </div>
          <div v-if="!isNew">
            <visit
              title="回访记录"
              :user-id="$route.params.id"
              :data-url="`/job/visit/paginate/userid/${$route.params.id}`"
              delete-url="/job/visit/resource/id/"
              :table-opt-permission="isJobSite"
              :btn-opt-permission="$hasPermission([1, 90, 98, 109, 114, 115, 116]) && isJobSite"
            />
            <visit
              title="运营回访"
              :user-id="$route.params.id"
              :data-url="`/job/operate_visit/paginate/userid/${$route.params.id}`"
              delete-url="/job/operate_visit/resource/id"
              type="jobOperate"
              :crm-level-lv="editData.crm_level_lv"
              :btn-opt-permission="$hasPermission([117]) && isJobSite"
              :table-opt-permission="(!infoReadOnly() || this.$hasPermission(117)) && isJobSite"
            />
          </div>
          <!--快速保存按钮-->
          <el-button
            v-if="!infoReadOnly() || canEditByCreator()"
            class="edit-fixed"
            type="success"
            size="mini"
            :loading="saving"
            @click="save()">保存</el-button>
        </div>
      </div>
    </div>
    <sync-dialogs
      v-if="isJobSite"
      @confirm="doSync"
      @loaded="syncDataLoaded"
      :type="syncType"
      width="30%"
      :from="editData.id"
      :visible.sync="syncDialogVisible">
    </sync-dialogs>
  </div>
</template>
<script>
import studentMixin from '@/pages/student/student.js';
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import { jmChannel, jmDictSelect, jmUploadFile } from '@/components/tool';
import syncDialogsMixin from '@/components/syncDialogsMixin';
import infoMenu from '@/components/infoMenu';
import { CREATOR_JOB_TO_FIB, CREATOR_JOB_TO_TRAINING } from '@/const/sync';
import * as http from '@/utils/http.js';

const visit = () => import('@/components/visit');

export default {
  mixins: [studentMixin, syncDialogsMixin],
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
    jmDictSelect,
    jmChannel,
    jmUploadFile,
    infoMenu,
    visit,
  },
  data() {
    return {
      exporting: false,
      saving: false,
      isNew: true,
      activeNames: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
      editData: {
        id: 0,
        creator: '',
        create_point: 0,
        custom_promoter: 0,
        skill_type: '',
        channel: {
          custom_from: '',
          custom_from_thrid: '',
          custom_from_fourth: '',
          custom_from_fifth: '',
          custom_from_sub: ''
        },
        jap_card: '',
        is_effective: '',
        upload_file: '',
        file_name: '',
        education_card: '',
        consult_teacher: '-1',
        clerk_teacher: '',
        remark: '',
        sign_date: '',
        sign_status: 0,
        project_type: '',
        member_level: 0,
        jap_level: '',
        major: '',
        education: '', // 学历
        birthday: '',
        username: '',
        nickname: '',
        qq: '',
        sex: '',
        tel: '',
        wechat: '',
        email: ''
      },
      refresh: false,
      ds: {},
      sign_status: [], // 签约状态
      consult_teacher_add: [], // 新增时，咨询老师
      clerk_teacher: [], // 材料老师
      consult_teacher_edit: [], // 编辑时，咨询老师
      clerk_teacher_list: [], // 材料老师
      creator_list: [],
    };
  },
  async beforeRouteEnter(to, from, next) {
    if (to.meta.isNew) {
      next();
      return true;
    }
    const { data } = await http._post({ url: '/job/member/read', data: { id: to.params.id } });
    next(vm => vm.setMemberInfo(data));
  },
  methods: {
    /**
     * 创建人为是否为当前登录者可编辑
     */
    canEditByCreator() {
      if (this.isNew) {
        return true;
      }
      return this.userInfo.userid === Number(this.editData.creator);
    },
    /**
     * 只读类信息
     */
    infoReadOnly() {
      // 其他系统信息只读
      if (!this.isJobSite) {
        return true;
      }
      if (this.isNew) {
        return false;
      }
      if (this.userInfo.userid === Number(this.editData.consult_teacher)) {
        return false;
      }
      if (this.$hasPermission([1, 98, 114, 116])) {
        return false;
      }
      return true;
    },
    setMemberInfo(data) {
      this.isNew = false;
      this.editData = data;
      this.consult_teacher_edit = data.consult_teacher_edit;
      this.clerk_teacher = data.clerk_teacher_list;
    },
    uploadBack(file) {
      this.exporting = false;
      if (file.result === 0) {
        this.editData.upload_file = file.data.filePath;
        this.editData.file_name = file.data.fileName;
      } else {
        this.$message.error(file.msg);
      }
    },
    loading() {
      this.exporting = true;
    },
    // 保存数据
    save() {
      if (!this.hasContactInfo(this.editData.tel, this.editData.wechat)) {
        if (this.editData.id && !this.hasContactInfo(this.editData.qq)) {
          this.$message.error('请填写联系方式');
          this.$refs.telInput.focus();
          return false;
        }
        if (!this.editData.id) {
          this.$message.error('必须填写微信或手机号');
          this.$refs.telInput.focus();
          return false;
        }
      }

      this.saving = true;
      this.$http
        ._post({
          url: '/job/member/save',
          data: {
            editData: this.editData
          }
        })
        .then(({ data }) => {
          this.saving = false;
          if (data.code === -1) {
            this.$message.error(data.msg);
          } else {
            this.$message.success(data);
          }
        });
    },
    async syncToFib(id, to, message) {
      await this.$http._post({
        url: '/job/member/syncToFib',
        data: { id, message, to }
      });
    },
    async syncToTraining(id, message, targetLan) {
      await this.$http._post({
        url: '/job/member/syncToTraining',
        data: { id, message, targetLan }
      });
    },
    /**
     * 进行同步
     */
    async doSync({
      system, message, to, targetLan
    }) {
      if (system === CREATOR_JOB_TO_FIB) {
        await this.syncToFib(this.editData.id, to, message);
      }
      if (system === CREATOR_JOB_TO_TRAINING) {
        await this.syncToTraining(this.editData.id, message, targetLan);
      }
      this.$message.success('同步成功');
      this.hideSyncDialog();
    },
  },
  mounted() {
    this.$http
      ._get({
        url: '/job/member/getDic'
      })
      .then(({ data }) => {
        this.sign_status = data.sign_status;
        this.consult_teacher_add = data.consult_teacher_add;
        this.creator_list = data.creator_list;
        // delete this.is_effective[0];
        if (this.isNew) {
          // 扩展权限
          // if (this.$hasExtendPower('job', 'consult_select')) {
          //   this.consult_teacher_add = Object.assign({ '-1': '自动分配' }, data.consult_teacher);
          //   // this.consult_teacher_add = data.consult_teacher;
          //   this.editData.consult_teacher = '-1'; // 自动分配
          // } else {
          //   this.editData.consult_teacher = Object.keys(this.consult_teacher_add)[0];
          // }
          this.consult_teacher_add = Object.assign({ '-1': '自动分配' }, data.consult_teacher);
          this.editData.consult_teacher = Object.keys(this.consult_teacher_add)[0];
          this.editData.creator = data.creator;
        }
      });
    if (this.isNew) {
      this.editData.custom_promoter = this.userInfo.userid;
      this.editData.create_point = -289;
    }
  }
};
</script>
<style scoped>
td:nth-child(odd) {
  word-break: keep-all;
}
.basic-title {
  height: 35px;
  line-height: 35px;
  margin: 10px 8px 15px;
  position: relative;
  cursor: default;
  border-bottom: 1px solid #b8c4ce;
}

.basic-table {
  width: 100%;
}
.basic-table th {
  padding: 3px 0;
  background-color: #e2eaf0;
  border-bottom: solid 1px #b8c4ce;
  cursor: pointer;
}
.basic-table th span {
  margin-left: 10px;
}
.basic-information {
  padding: 8px;
}
.basic-table th i {
  font-size: 14px;
  line-height: 26px;
}
.basic-table th i:after {
  display: inline-block;
  margin-left: 10px;
  content: '\e608';
}
.basic-table .el-row .el-col {
  display: flex;
  align-items: center;
  min-height: 55px;
  padding-left: 8px;
  border-right: solid 1px #b8c4ce;
  border-bottom: solid 1px #b8c4ce;
}
.basic-table-info .el-row:nth-child(2) .el-col {
  font-weight: bold;
}
.basic-table .scores-info .el-row .el-col {
  border-right: none;
  border-bottom: none;
  padding-left: 0;
}
.basic-table .scores-jmte {
  padding-left: 0 !important;
  border-bottom: none !important;
  border-right: none !important;
}
.mindMapping a {
  text-decoration: underline;
  color: #000;
}
</style>

<style>
.diff_column input.el-input__inner {
  border-color: red;
}
.diff_column .el-select input.el-input__inner {
  border-color: red;
}
.basic-table-div .el-form-item__content {
  line-height: inherit !important;
}
.title-bottom {
  float: right;
  margin: 0 20px;
}
.edit-file-download {
  margin-left: 20px;
}
</style>
